"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cookieSettings = _interopRequireDefault(require("../styles/cookie-settings.css"));
var _clsx = _interopRequireDefault(require("clsx"));
var CookieSettings = function CookieSettings() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _cookieSettings["default"].buttonContainer
  }, /*#__PURE__*/_react["default"].createElement("button", {
    id: "ot-sdk-btn",
    className: (0, _clsx["default"])(_cookieSettings["default"].toBeReplaced, 'ot-sdk-show-settings')
  }));
};
var _default = CookieSettings;
exports["default"] = _default;